import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../slices/authSlice';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { SidebarTrigger } from './ui/sidebar';
import NotificationBell from './NotificationBell';
import AppSwitcher from './AppSwitcher';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/auth/login');
  };

  return (
    <header
      className="flex h-14 shrink-0 items-center gap-3 border-b border-border px-4 sm:h-16 sm:px-5"
      style={{ backgroundColor: '#0b0e11' }}
    >
      <SidebarTrigger className="h-9 w-9 rounded-md border border-border/70 bg-white/[0.02] text-muted-foreground transition-colors hover:bg-white/[0.05] hover:text-foreground [&_svg]:h-4 [&_svg]:w-4" />

      {/* Page label */}
      <div className="flex min-w-0 flex-1 items-center gap-2 font-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">
        <span className="hidden sm:inline text-muted-foreground/50">Ginox</span>
        <span className="hidden sm:inline text-muted-foreground/30">/</span>
        <span className="text-foreground">Admin Panel</span>
      </div>

      {/* Right: app switcher + notifications + user + logout */}
      <div className="flex items-center gap-3">
        <AppSwitcher inApp />
        {user && (
          <span className="hidden sm:block truncate max-w-[160px] text-xs text-muted-foreground">
            {user.email || user.name || user.username}
          </span>
        )}
        <NotificationBell />
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 rounded-md border border-border/70 bg-white/[0.02] px-3 py-1.5 text-xs text-muted-foreground transition-colors hover:bg-white/[0.05] hover:text-foreground"
        >
          <LogOut className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;
